import React, { useState } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
// import FiltersPartial from "./FiltersPartial.js";

const Index = () => {
  const defaultHeaderConfig = { disableSort: true };
  // const [filtersModel, setFiltersModel] = useState({});
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Circle Name',
      value: (row) => {
        return <div>
          {row.circle.name}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'VAK Name',
      value: (row) => {
        return <div>
          {row.glk.name}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'VAK Value',
      value: (row) => {
        return <div>
          {row.glk.amount}
        </div>
      },
    },

    {
      ...defaultHeaderConfig,
      label: 'Channel Partner Code',
      attr: 'channel_partner_code',
    },
    {
      ...defaultHeaderConfig,
      label: 'PP/Dealer Firm Name',
      attr: 'firm_name',
    },
    {
      ...defaultHeaderConfig,
      label: 'PP SLOC',
      value: (row) => {
        return <div>
          {row.manager.sloc}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Customer ID',
      attr: 'cus_nomenclature_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'RMN',
      value: (row) => {
        return <div>
          {row.mobile_numbers[0]}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Customer',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      value: (row) => {
        return <div>
          {row.role_status.status}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
    },
    {
      ...defaultHeaderConfig,
      label: 'Vehicle Type',
      value: (row) => {
        return <div>
          {row.vehicle_type.type}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Offer',
      value: (row) => {
        return <div>
          {row.offer.name}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Work Order ID',
      value: (row) => {
        return <div>
          {row.work_order.nomenclature}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Work Order',
      value: (row) => {
        return <div>
          {row.work_order.ticket?.name}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Lease Rental Amount',
      attr: 'customer_lease_rental_amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Activation Amount',
      attr: 'customer_activation_amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Serial No.',
      attr: 'rfid_serial_number',
    },
    {
      ...defaultHeaderConfig,
      label: 'DSC Code',
      attr: 'dsc_code',
    },
    {
      ...defaultHeaderConfig,
      label: 'DSC SLOC',
      attr: 'dsc_sloc',
    },
    {
      ...defaultHeaderConfig,
      label: 'Scheme',
      attr: 'scheme_name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Conversion/New Sales',
      value: (row) => {
        return <div>
          {row.category.name}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'No. of received Batteries',
      value: (row) => {
        return <div>
          {row.vehicle_type.no_of_old_batteries}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Issued Batteries',
      value: (row) => {
        return <div>
          {row.issued_batteries.map(item => <div key={item.serial_number}>{item.serial_number}</div>)}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Customer Recharge Amount',
      attr: 'customer_recharge_amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Remark',
      attr: 'remark',
    },
  ]

  return <ListingPageComponent
    key={PAGES.VoltUpAllocationKitReportsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.VoltUpAllocationKitReportsListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'VAK Reports'}]}
    listingMutation={getApi('vakReports')}
    recordsKey="glk_reports"
    className="vak-reports-listing-page"
    contentHeading="VAK Reports List - Results"
    headers={headers}
    // filters={
    //   <FiltersPartial
    //     filtersModel={filtersModel}
    //     setFiltersModel={setFiltersModel}
    //   />
    // }
    searchBy={['VAK Name', 'Customer ID', 'Customer']}
  />
};

export default Index;
